import verifKtp from 'assets/images/verif-ktp.png'
import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import FullModal from 'components/Modal/FullModal'
import { useEffect, useState } from 'react'
import { ArrowLeft, Clock } from 'react-feather'
import { useSelector } from 'react-redux'
import { Card, Modal } from 'reactstrap'

export default function Verification({ profile }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const publicVersion = useSelector((s) => s.publicVersion)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const onToVerif = () => {
    let url = `${process.env?.REACT_APP_VERIFICATION_URL}/langsungaja?verificationCode=${profile?.data?.ownerData?.verificationCode}&r=business`
    window.location.href = url
  }

  const onToWhatsapp = () => {
    const noCsPasmik = publicVersion?.data?.csNumber || '6285157570025'
    const userName = profile?.data?.ownerData?.companyName || profile?.data?.ownerData?.name || ''
    const userId = profile?.data?.ownerData?.userId || ''
    const message = encodeURIComponent(
      `Halo PasarMIKRO, akun saya dengan nama ${userName} dan userID ${userId} saat ini masih dalam status menunggu persetujuan. Mohon bantuannya untuk memproses verifikasi akun saya. Terima kasih.`
    );
    window.open(`https://wa.me/${noCsPasmik}?text=${message}`, '_blank')
  }

  if (profile?.data?.ownerData?.status === 'WAITAPPROVAL') {
    return (
      <Card className="mb-3 p-3" lg="4" sm="12" style={{ border: 'none' }}>
        <div className="d-flex align-items-start gap-3">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: '#FFEAD5',
              color: '#F38B2B',
              width: '40px',
              height: '40px',
              flexShrink: 0,
              marginTop: '4px',
            }}
          >
            <Clock size={20} />
          </div>
          <div className="flex-grow-1">
            <P bold style={{ color: '#1e293b' }}>
              Menunggu Verifikasi
            </P>
            <P size="regular" style={{ color: '#64748b', marginBottom: '12px' }}>
              Pendaftaran Anda telah diterima dan sedang dalam proses verifikasi. Mohon tunggu hingga proses selesai.
            </P>
            <CustomButton
              onClick={onToWhatsapp}
              color="primary"
              outline
              style={{
                borderColor: '#D0D5DD',
              }}
              testId="verification-whatsapp-button"
            >
              <P size="regular">Hubungi PasarMIKRO (WhatsApp)</P>
            </CustomButton>
          </div>
        </div>
      </Card>
    )
  }

  if (profile?.data?.ownerData?.status === 'UNVERIFIED') {
    return (
      <>
        <Card className="mb-3 p-3" lg="4" sm="12" style={{ border: 'none' }}>
          <P bold>Selamat datang di PasarMIKRO!</P>
          <P size="regular">
            Ayo verifikasi akun Anda agar bisa menggunakan semua fitur seperti
            transaksi dan lainnya!
          </P>
          <CustomButton
            onClick={onToVerif}
            className="mt-3"
            outline
            color="primary"
            style={{
              borderColor: '#D0D5DD',
            }}
            testId="verification-verif-now-button"
          >
            <P>Verifikasi Sekarang</P>
          </CustomButton>
        </Card>
        {/* {renderModal()} */}
      </>
    )
  }

  function contentVerification() {
    return (
      <div>
        <div
          className="p-3 d-flex gap-4"
          style={{ borderBottom: '1px solid #D0D5DD' }}
        >
          <ArrowLeft color="#667085" />
          <P>Verifikasi akun</P>
        </div>
        <div className="d-flex justify-content-center mt-5 mb-5">
          <img src={verifKtp} style={{ width: 250, height: 250 }} />
        </div>
      </div>
    )
  }

  function renderModal() {
    return (
      <>
        {isMobile ? (
          <FullModal isOpen={true}>
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                justifyContent: 'flex-start',
              }}
            >
              {contentVerification()}
            </div>
          </FullModal>
        ) : (
          <Modal isOpen={true} centered>
            {contentVerification()}
          </Modal>
        )}
      </>
    )
  }
}
